<template>
  <div class="main-content">
    <div class="card">
      <div class="card-header">
        <h6>Операции за период</h6>
      </div>
      <div class="card-body">
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
        <div v-if="!loading && balance">
          <div class="flex flex_gap_10">
            <div class="card bg-success">
              <div class="card-body">
                <p>Баланс на <strong>сегодня</strong></p>
                <h5><strong>{{ (activeBalance ?? 0).toLocaleString('ru-RU') }}</strong></h5>
              </div>
            </div>
            <div class="card bg-info">
              <div class="card-body">
                <p>Баланс на <strong>{{ printDate(balance.actual_date, 'DD.MM.YYYY') }}</strong></p>
                <h5><strong>{{ (balance?.balance?.[33]?.orders ?? 0).toLocaleString('ru-RU') }}</strong></h5>
              </div>
            </div>
          </div>
          <div>
            <table class="table table-hover table-sm mt-1">
              <thead>
              <tr>
                <th></th>
                <th></th>
                <th></th>
                <th>сумма</th>
                <th>дата</th>
                <th>сальдо</th>
              </tr>
              </thead>
              <tbody>
              <template v-for="(records, timestamp, ii) in getSortedRecord()">
                <tr v-for="(record, i) in records" :class="{'odd': ii % 2}">
                  <td>{{ i + 1 }}</td>
                  <td>
                    <i
                      :class="{'icon-fa': true,
                    'icon-fa-minus-square': record.operation === '-',
                    'icon-fa-plus-square': record.operation === '+'}"/>
                  </td>
                  <td>
                    <template v-if="record.typeAlias === 'income'">
                      <p>Инкассация</p>
                      <template v-if="+record.type_id === 2">
                        <p>обмен на Tether</p>
                      </template>
                      <template v-else>
                        <p class="text-muted">{{ $AllDivisions[record.division_id]?.title }}</p>
                        <p class="text-muted">{{ record.comment }}</p>
                      </template>
                    </template>
                    <template v-else>
                      <p>{{ record.type.title }}</p>
                      <p class="text-muted">{{ record.comment }}</p>
                    </template>
                  </td>
                  <td><strong>{{ record.sum }}</strong></td>
                  <td class="group_date" v-if="i === 0" :rowspan="records.length">
                    {{ printDate(record.timestamp, 'DD.MM.YYYY') }}
                  </td>
                  <td align="right"><strong>{{ record.balance_change.toLocaleString('ru-RU') }}</strong></td>
                </tr>
              </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  data() {
    return {
      loading: false,
      balance: null,
      incomes: [],
      expenses: [],
      activeBalance: null,
    }
  },
  created() {
    this.getRecords();
  },
  methods: {
    getSortedRecord() {
      let sum = this.balance?.balance?.[33]?.orders ?? 0;

      const records = _.orderBy(([...this.incomes, ...this.expenses].map((r) => {
        const record = {...r};
        if (record.report_date) record.timestamp = Date.parse(record.report_date);
        if (record.pass_date) record.timestamp = Date.parse(record.pass_date);
        return record;
      })), 'timestamp');

      const sorted = records.reduce((acc, r) => {
        if (!acc[r.timestamp]) acc[r.timestamp] = [];
        r.operation = '-';
        r.typeAlias = 'expense';
        if (r.report_date) {
          r.typeAlias = 'income';
          if (+r.division_id === +this.balance?.division_id) {
            sum = sum - r.sum;
          } else {
            r.operation = '+';
            sum = sum + r.sum;
          }
        } else {
          sum = sum - r.sum;
        }
        r.balance_change = sum;
        acc[r.timestamp].push(r);
        return acc;
      }, {})
      this.activeBalance = sum;
      return sorted;
    },
    async getRecords() {
      this.loading = true;
      const {data} = await api.index('/reports/division/operations/period');
      if (data.success) {
        this.incomes = data.incomes;
        this.expenses = data.expenses;
        this.balance = data.balance;
      } else {
        toastr['warning'](data.message || 'ошибка сервера', 'Неуспешно')
      }
      this.loading = false;
    }
  }
}
</script>

<style scoped>
.card .card-body {
  padding: 15px;
}

.card p,
.card h5 {
  margin-bottom: 0;
}

.border {
  padding: 10px;
}

.border p {
  margin-bottom: 0;
}

.icon-fa-plus-square {
  color: green;
}

.icon-fa-minus-square {
  color: red;
}

table.table tr.odd {
  background-color: rgba(0, 0, 0, .05);
}

table th,
table td {
  padding: 3px;
}

.group_date {
  border: 1px solid lightgray;
  text-align: center;
}
</style>
